import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.LA_RANA_BRINCACHARCOS;

export const LEVEL_MASTERY_THRESHOLD = 0.8;

export const SCREENS = {
  LOADING: 'LOADING',
  PROGRESS: 'PROGRESS',
  ONBOARDING: 'ONBOARDING',
  STANDARD: 'STANDARD',
  INSTRUCTION: 'INSTRUCTION',
  DEV_ONLY: 'DEV_ONLY',
};

export const REDUX_ACTIONS = {
  INIT_STANDARD_ROUND: 'INIT_STANDARD_ROUND',
  SET_INSTRUCTION_WORD_AND_SYLLABLES: 'SET_INSTRUCTION_WORD_AND_SYLLABLES',
  CLEAR_INSTRUCTION_WORD_AND_SYLLABLES: 'CLEAR_INSTRUCTION_WORD_AND_SYLLABLES',
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_LEVEL_ITEMS_COUNT: 'SET_LEVEL_ITEMS_COUNT',
  INCREMENT_PROGRESS_COUNT: 'INCREMENT_PROGRESS_COUNT',
  INCREMENT_CORRECT_COUNT: 'INCREMENT_CORRECT_COUNT',
  INCREMENT_ITEM_INDEX: 'INCREMENT_ITEM_INDEX',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
};

export const ANIMATION_TYPE = {
  FROG_INIT_POINT: 'FROGINITPOINT',
  FROG_JUMP: 'FROGJUMP',
};

export const LEVEL_BACKGROUNDS = {
  SWAMP: 'swamp',
  BACKYARD: 'backyard',
  POTHOLE: 'pothole',
  NIGHTSWAMP: 'nightswamp',
  GARDEN: 'garden',
  FOUNTAIN: 'fountain',
  ICE: 'ice',
};

export const ONBOARDING_BACKGROUND = 'yellowSwamp';

export const ONBOARDING_TYPES = {
  PROMPT: 'prompt',
  INTERACTION: 'interaction',
};

export const COLORS = {
  DARK_GREEN: '#2c8219',
  WHITE: 'white',
  BLACK: 'black',
  YELLOW_GREEN: '#ff9',
};

export const BORDER_COMPONENT_IDS = {
  WORD_CARD: 'wordCard-bordered',
  ELKON_BOXES: 'ElkonBoxes-bordered',
  MUSIC_BUTTON: 'musicButton-bordered',
  OK_BUTTON: 'ok-bordered',
};
